<template>
<footer>
  <div class="wrapper">

    <section class="social-signup">
      <div class="social-links">
        <a href="https://www.facebook.com/OpenTrons-Labworks/" target="_blank"
        data-gtm-action="click"
        data-gtm-category="Social"
        data-gtm-label="Open Facebook"
        ><img src="https://s3.amazonaws.com/opentrons-images/website/logo_facebook.png" alt="facebook logo"/></a>
        <a href="https://twitter.com/OpenTrons_" target="_blank"
        data-gtm-action="click"
        data-gtm-category="Social"
        data-gtm-label="Open Twitter"><img src="https://s3.amazonaws.com/opentrons-images/website/logo_twitter.png" alt="twitter logo" /></a>
        <a href="https://www.instagram.com/opentronslab/" target="_blank"
        data-gtm-action="click"
        data-gtm-category="Social"
        data-gtm-label="Open Instagram"><img src="https://s3.amazonaws.com/opentrons-images/website/logo_instagram.png" alt="instagram logo" /></a>
        <a href="https://www.youtube.com/channel/UCvMRmXIxnHs3AutkVhuqaQg" target="_blank"
        data-gtm-action="click"
        data-gtm-category="Social"
        data-gtm-label="Open Youtube"><img src="https://s3.amazonaws.com/opentrons-images/website/logo_youtube.png" alt="youtube logo" /></a>
      </div>
      <h3>Sign Up For Our Newsletter</h3>
      <div id="mc_embed_signup">
        <form action="//opentrons.us8.list-manage.com/subscribe/post?u=000595683fb96c5fb3c54cf53&amp;id=ba66060a9c" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
          <div id="mc_embed_signup_scroll">
            <input type="email" value="" name="EMAIL" class="email-newsletter" id="mce-EMAIL" placeholder="email address" required
            data-gtm-action="input"
            data-gtm-category="Mailchimp"
            data-gtm-label="Enter Email"
            >
            <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_000595683fb96c5fb3c54cf53_ba66060a9c" tabindex="-1" value=""></div>
            <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="gray subscribe"
            data-gtm-action="click"
            data-gtm-category="Mailchimp"
            data-gtm-label="Newsletter Signup">
          </div>
        </form>
      </div>
      <p class="copyrite">&#169;&nbsp;OPENTRONS 2017</p>
    </section>
    <section class="footer-menu">
      <ul>
        <li>Products</li>
        <li><a href="https://opentrons.com/robots">OT-One</a></li>
        <li><a href="https://opentrons.com/ot-2">OT-2</a></li>
        <li><a href="https://opentrons.com/pipettes">Pipettes</a></li>
        <li><a href="https://opentrons.com/modules">Modules</a></li>
        <li><a href="https://opentrons.com/ot-app">OT App</a></li>
        <li><a href="https://protocols.opentrons.com/">Protocol Library</a></li>
      </ul>
      <ul>
        <li>Company</li>
        <li><a href="https://opentrons.com/about">About</a></li>
        <li><a href="https://opentrons.com/team">Team</a></li>
        <li><a href="https://blog.opentrons.com/">Blog</a></li>
        <li><a href="https://opentrons.com/contact">Contact Us</a></li>
        <li><a href="https://opentrons.com/jobs" target="_blank" class="hiring">WE'RE HIRING</a></li>
      </ul>
      <ul>
        <li>Resources</li>
        <li><a href="https://support.opentrons.com" target="_blank">Support</a></li>
        <li><a href="https://support.opentrons.com/getting-started" target="_blank">Getting Started</a></li>
          <li><a href="http://docs.opentrons.com/" target="_blank">Opentrons API</a></li>
          <li><a href="https://github.com/Opentrons/opentrons" target="_blank">Open Source</a></li>
      </ul>
      <ul>
        <li><a href="https://shop.opentrons.com/" class="buy">Buy</a></li>
      </ul>

    </section>

  </div>
</footer>
</template>

<script>
  export default {
    name: 'SiteFooter'
  }
</script>

<style scoped>
    .wrapper .hiring{
    color: #05C1B3;

  }
</style>



// WEBPACK FOOTER //
// SiteFooter.vue?32eb448c